import { createApi } from "@reduxjs/toolkit/query/react";
import { getLoggedinUser, getUser, logout } from "../userStore";
// import { getBaseUrl } from "../utils/common_lib";
const customBaseQuery = async (args, api, extraOptions) => {
  let baseUrl = "";

  // let checkPractice = localStorage.getItem("organization_code");
  // let organization_config = localStorage.getItem("organization_config");
  // //if checkPractice match the name key in organization_config then return the api_url

  // let organization_config_obj = JSON.parse(organization_config);
  // let checkPracticeObj = organization_config_obj?.find((item) =>
  //   item?.short_code?.toLowerCase()?.includes(checkPractice?.toLowerCase())
  // );
  // if (checkPracticeObj?.api_url) {
  //   baseUrl = checkPracticeObj?.api_url;
  // } else {
  //   baseUrl = process.env.REACT_APP_API_URL_V1;
  // }

  let server_api=JSON.parse(localStorage.getItem("baseUrl"))
  if (server_api) {
    baseUrl = server_api
  } else {
    baseUrl = process.env.REACT_APP_API_URL_V1;
  }
  

  const userData = getUser();

  // Prepare headers with the access token (if available)
  const headers = new Headers({
    "Content-Type": "application/json",
    // Authorization: accessToken ? `Bearer ${accessToken}` : "",
  });

  const { url = null, params, body, ...rest } = args;

  let finalParams = {
    tz: new Date().getTimezoneOffset(),
    portal: "patient",
    ...params,
  };

  if (userData && userData["token"]) {
    finalParams = {
      ...finalParams,
      practice_id: userData["practice_id"],
      is_patient: userData["is_patient"],
      token: userData["token"],
    };
    if (!finalParams.pid) {
      finalParams.pid = userData.pid;
    }
  }

  const queryString = new URLSearchParams(finalParams).toString();

  const requestUrl =
    baseUrl + (url || "") + (queryString ? `?${queryString}` : "");

  try {
    const response = await fetch(requestUrl, {
      headers,
      body: JSON.stringify(body),
      ...rest,
    });

    // Check for successful response
    if (!response.ok) {
      if (response.status === 401) {
        // Handle unauthorized case (e.g., refresh token or logout)
        console.error("Unauthorized request!");
        // Implement refresh token logic or logout action here
      } else {
        // Handle other error cases
        throw new Error(await response.text());
      }
    }

    const data = await response.json();
    if (data?.response?.code === -2) {
      // Handle unauthorized case (e.g., refresh token or logout)
      console.error("Unauthorized request!");
      logout();
      // Implement refresh token logic or logout action here
    }

    return { data };
  } catch (error) {
    return { error };
  }
};

export const baseApi = createApi({
  reducerPath: "api",
  baseQuery: customBaseQuery, //customBaseQuery, in which you can add your own logic,like adding toekn headers, handling errors, etc.
  endpoints: () => ({}),
  // refetchOnMountOrArgChange: true,
  keepUnusedDataFor: 0,
});
